import React from "react";
import styled from "styled-components";
import classNames from "classnames";
import moment from "moment";

import Splat from "components/SatisfactionSurveys/SatisfactionSurveysIndex/Dashboard/SatisfactionFeedback/FeedbackTable/FeedbackRow/Splat";

const DEFAULT_NAME_PROP = "identity.name";
const DEFAULT_EMAIL_PROP = "identity.email";

// helper that takes an object and a string representing a dotted path to a subfield in that object
// and extracts that value, or null if that path is invalid.
//
// example:
// unDot(foo, "bar.baz") will extract foo.bar.baz
//
const unDot = (data, path) => {
  let value = data;
  path.split(".").forEach(subField => {
    value = (value || {})[subField];
  });
  return value || null;
};

const FeedbackRow = props => {
  const { className, rowData, priority, emailProp, userNameProp } = props;

  const noFeedback = <span className="no-feedback">No Feedback</span>;
  const noEmail = <span className="no-email">Unknown Email Address</span>;
  const noIdentityName = <span className="no-identity-name">Unknown Name</span>;

  const dottedNameProp = userNameProp
    ? `identity.${userNameProp}`
    : DEFAULT_NAME_PROP;
  const nameData = unDot(rowData, dottedNameProp);

  const dottedEmailProp = emailProp
    ? `identity.${emailProp}`
    : DEFAULT_EMAIL_PROP;
  const email = unDot(rowData, dottedEmailProp);

  const emailLink = (
    <a className="email-link" href={`mailto:${email}`}>
      {email}
    </a>
  );

  return (
    <tr className={className}>
      <td className={classNames("timestamp", priority ? "priority" : null)}>
        {moment(rowData.timestamp).calendar()}
      </td>
      <td className="score">
        <div className={classNames("score-bubble", `score-${rowData.score}`)}>
          {rowData.score === 10 ? (
            <Splat>
              <span className="score-10-label">{rowData.score}</span>
            </Splat>
          ) : (
            rowData.score
          )}
        </div>
      </td>
      <td className="identity-name" title={nameData}>
        {nameData || noIdentityName}
      </td>
      <td className="email">{email ? emailLink : noEmail}</td>
      <td className="feedback">
        {rowData.feedback ? rowData.feedback : noFeedback}
      </td>
    </tr>
  );
};

export default styled(FeedbackRow)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0;
  min-height: 55px;

  td {
    color: #5d5d5d;

    &:first-of-type {
      padding-left: 0px;
    }

    &.timestamp {
      font-weight: bold;
      color: #a7a7a7;
      width: 220px;

      &.priority {
        color: #666;
      }
    }

    &.score {
      width: 40px;
    }

    &.identity-name {
      width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &.email {
      width: 230px;
      overflow-wrap: break-word;
    }

    a.email-link {
      color: #16a8d1;
    }

    &.feedback {
      width: 35%;
    }

    span.no-feedback,
    span.no-email,
    span.no-identity-name {
      font-style: italic;
      color: #a7a7a7;
    }
  }

  .score-bubble {
    box-sizing: border-box;
    width: 31px;
    height: 31px;
    padding-top: 3px;
    border-radius: 50%;
    font-size: 19px;
    text-align: center;
    font-weight: bold;
    color: #fff;

    &.score-0 {
      background-color: #ef4546;
    }

    &.score-1 {
      background-color: #ef4546;
    }

    &.score-2 {
      background-color: #ef4546;
    }

    &.score-3 {
      background-color: #ef4546;
    }

    &.score-4 {
      background-color: #ef4546;
    }

    &.score-5 {
      background-color: #ef4546;
    }

    &.score-6 {
      background-color: #ef4546;
    }

    &.score-7 {
      background-color: #e2e2e2;
      color: #999;
    }

    &.score-8 {
      background-color: #e2e2e2;
      color: #999;
    }

    &.score-9 {
      background-color: #06db82;
    }

    &.score-10 {
      width: 35px;
      height: 35px;
      border-radius: 0;
      font-size: 18px;

      > div {
        height: inherit;
        width: inherit;
      }

      .score-10-label {
        position: relative;
        bottom: 36px;
      }
    }
  }
`;
